/**
 * Position du carrousel mobile de la fiche à la fermeture de la galerie : la dernière photo vue
 * (`index`), bornée aux diapositives présentes. `null` quand il n'y a rien à faire : carrousel masqué
 * (largeur nulle, ordinateur), vide, ou déjà sur cette photo.
 */
export function carouselScrollLeft(
    index: number,
    slides: number,
    slideWidth: number,
    scrollLeft: number,
): number | null {
    if (slideWidth <= 0 || slides <= 0) return null;
    const target = Math.min(Math.max(index, 0), slides - 1);
    if (Math.round(scrollLeft / slideWidth) === target) return null;
    return target * slideWidth;
}
